import { BlockType } from '@common/enums';
import { never } from '@common/utils/never';
import type { IGraphSizes } from './helpers';
import type { IProcessWorkflowStep, IServiceWorkflowStep } from './WorkflowGraph';
import { ActionStep, ActivityStep, ChoiceStep, GeneralStep, StartStep, SystemActionStep } from './shapes';

interface IStepProps {
    graphSizes: IGraphSizes;
    onMouseOut: () => void;
    onMouseOver: (step: [IServiceWorkflowStep, IProcessWorkflowStep?]) => void;
    processWorkflowSteps: IProcessWorkflowStep[];
    serviceWorkflowStep: IServiceWorkflowStep;
}

export function Step(props: IStepProps) {
    const { serviceWorkflowStep, processWorkflowSteps, graphSizes, onMouseOver, onMouseOut } = props;

    const shapes: JSX.Element[] = [];
    for (let i = 0; i < Math.max(1, processWorkflowSteps.length); i++) {
        const Shape = getShapeElement(serviceWorkflowStep.serviceWorkflowBlock.type);
        const shapePosition = { ...serviceWorkflowStep.displayOptions, offset: i };
        shapes.push(
            <Shape
                graphSizes={graphSizes}
                key={serviceWorkflowStep.id + i}
                label={serviceWorkflowStep.name}
                onMouseOut={onMouseOut}
                onMouseOver={() => onMouseOver([serviceWorkflowStep, processWorkflowSteps[i]])}
                position={shapePosition}
                processWorkflowStep={processWorkflowSteps[i]}
            />
        );
    }

    return <>{shapes}</>;
}

function getShapeElement(blockType: BlockType) {
    switch (blockType) {
        case BlockType.start:
            return StartStep;
        case BlockType.general:
        case BlockType.scheduled:
            return GeneralStep;
        case BlockType.activity:
            return ActivityStep;
        case BlockType.action:
            return ActionStep;
        case BlockType.choice:
            return ChoiceStep;
        case BlockType.systemAction:
            return SystemActionStep;
        default:
            never(blockType);
    }
}
